import { useContext } from "react";

//css
import styles from "../css/loadingalert.module.css";

//context
import { GlobalVars } from "../../../../contexts/GlobalVars";

//config
import { Languages } from "../../../../config/languages";

export function LoadingAlert() {
    const globalVars = useContext(GlobalVars);

    return(
        <div style={{
            zIndex:"var(--alert-layer0-zindex)",
            position:"absolute", 
            width:"100dvw", 
            height:"100dvh",
            backgroundColor:"var(--loadingalert-background)",
            display:"flex",
            justifyContent:"center",
            flexDirection:"column",
            left:"0px",
            top:"0px"
        }}>
            <div className={styles.content_loader}>
                <div className={styles.loader}></div>
                {/*<div className={styles.content_loader_container}>
                    <div className={styles.content_loader_bar}>	
                     <p className={styles.text}>1/100</p>	
                    </div>
                </div>*/}
            </div>
            <p style={{textAlign:"center", color:"var(--loadingalert-message-color)"}}>
                {Languages[globalVars.language].alertLoadingMessage}
            </p>
        </div>
    );
};